import React from "react";

export interface ProMatchTitleLogoProps {
  /** Tailwind / CSS classes — use h-* or w-* to control size */
  className?: string;
}

/**
 * ProMatch brand logo rendered as an `<img>` referencing the multi-color SVG.
 * Size it entirely via `className` (e.g. `h-10`, `w-40`).
 */
const ProMatchTitleLogo: React.FC<ProMatchTitleLogoProps> = ({ className }) => (
  <img
    src="/logos/promatch-brand.svg"
    alt="ProMatch Analytics"
    className={className}
    aria-hidden="true"
  />
);

export default ProMatchTitleLogo;
